import React from 'react';
import PropTypes from 'prop-types';

const MonthSelector = ({ theme, currentMonth, onMonthChange }) => {
  // Nombres de los meses
  const months = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];
  
  return (
    <div className={`GM__${theme}-month-selector`}>
      {months.map((month, index) => (
        <button
          key={`month-${index + 1}`}
          className={`GM__${theme}-month-button ${index === currentMonth ? 'active' : ''}`}
          onClick={() => onMonthChange(index)}
        >
          <span className={`GM__${theme}-month-icon`}>○</span>
          <span className={`GM__${theme}-month-name`}>{month}</span>
        </button>
      ))}
    </div>
  );
};

MonthSelector.propTypes = {
  theme: PropTypes.string.isRequired,
  currentMonth: PropTypes.number.isRequired,
  onMonthChange: PropTypes.func.isRequired
};

export default MonthSelector;